import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './PatientCreate.css';

const PatientCreate = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  // Initial form state
  const [formData, setFormData] = useState({
    hospital_patient_id: '',  // Required
    file_path: '',            // Required
    date_of_birth: null,        // Optional
    gender: null,               // Optional
    data_source: '',          // Required
    ethnicity: null,            // Optional
    diagnosis: null,            // Optional
    notes: null,                // Optional
    original_upload_path: '', // Required
  });

  const [error, setError] = useState('');

  // Update local state when form fields change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Submit form data to the backend
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/patients/create/`,
        formData,
        {
          headers: {
            Authorization: `Token ${token}`,
          },
        }
      );
      // If successful, redirect to patients list
      navigate('/patients');
    } catch (err) {
      console.error(err);
      setError('Error creating patient. Check fields or try again.');
    }
  };

  return (
    <div className="patient-create-container">
      <h2>Create New Patient</h2>
      {error && <div className="error-message">{error}</div>}
      <form onSubmit={handleSubmit} className="patient-create-form">
        
        {/* Hospital Patient ID - Required */}
        <div className="form-group">
          <label>
            Hospital Patient ID <span className="required-asterisk">*</span>
          </label>
          <input
            type="text"
            name="hospital_patient_id"
            value={formData.hospital_patient_id}
            onChange={handleChange}
            required
          />
        </div>
        
        {/* File Path - Required */}
        <div className="form-group">
          <label>
            File Path <span className="required-asterisk">*</span>
          </label>
          <input
            type="text"
            name="file_path"
            value={formData.file_path}
            onChange={handleChange}
            required
          />
        </div>
        
        {/* Date of Birth (Optional) */}
        <div className="form-group">
          <label>Date of Birth (Optional)</label>
          <input
            type="date"
            name="date_of_birth"
            value={formData.date_of_birth}
            onChange={handleChange}
          />
        </div>
        
        {/* Gender (Optional) */}
        <div className="form-group">
          <label>Gender (Optional)</label>
          <select
            name="gender"
            value={formData.gender}
            onChange={handleChange}
          >
            <option value="">Select Gender</option>
            <option value="M">Male</option>
            <option value="F">Female</option>
          </select>
        </div>
        
        {/* Data Source - Required */}
        <div className="form-group">
          <label>
            Data Source <span className="required-asterisk">*</span>
          </label>
          <input
            type="text"
            name="data_source"
            value={formData.data_source}
            onChange={handleChange}
            required
          />
        </div>
        
        {/* Ethnicity (Optional) */}
        <div className="form-group">
          <label>Ethnicity (Optional)</label>
          <input
            type="text"
            name="ethnicity"
            value={formData.ethnicity}
            onChange={handleChange}
          />
        </div>
        
        {/* Diagnosis (Optional) */}
        <div className="form-group">
          <label>Diagnosis (Optional)</label>
          <textarea
            name="diagnosis"
            value={formData.diagnosis}
            onChange={handleChange}
          />
        </div>
        
        {/* Notes (Optional) */}
        <div className="form-group">
          <label>Notes (Optional)</label>
          <textarea
            name="notes"
            value={formData.notes}
            onChange={handleChange}
          />
        </div>
        
        {/* Original Upload Path - Required */}
        <div className="form-group">
          <label>
            Original Upload Path <span className="required-asterisk">*</span>
          </label>
          <input
            type="text"
            name="original_upload_path"
            value={formData.original_upload_path}
            onChange={handleChange}
            required
          />
        </div>
        
        <button type="submit" className="create-button">
          Create Patient
        </button>
      </form>
    </div>
  );
};

export default PatientCreate;
